module.exports = __webpack_public_path__ + "img/phone.5c526a84.png";